import { render, staticRenderFns } from "./EventBackdropPromo.vue?vue&type=template&id=72480c17&scoped=true"
import script from "./EventBackdropPromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventBackdropPromo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventBackdropPromo.vue?vue&type=style&index=0&id=72480c17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72480c17",
  null
  
)

export default component.exports